import { StandardQuizQuestion } from '@/types/quizTypes';

export const SMART_IOT_SYSTEMS_QUIZ: StandardQuizQuestion[] = [
  {
    id: "iot-smart-1",
    question: "What is the primary purpose of edge computing in IoT systems?",
    options: [
      "Store all data in the cloud",
      "Process data closer to the source to reduce latency",
      "Increase network bandwidth",
      "Replace cloud computing entirely"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Edge computing processes data at or near the source (edge devices) rather than sending everything to the cloud. This reduces latency, saves bandwidth, and enables real-time decision-making.",
    category: "edge-computing",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "iot-smart-2",
    question: "Which protocol is most commonly used for lightweight IoT messaging?",
    options: [
      "HTTP",
      "MQTT",
      "FTP",
      "SOAP"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "MQTT (Message Queuing Telemetry Transport) is a lightweight publish-subscribe protocol designed for IoT devices with limited bandwidth and resources. It's ideal for sensor networks.",
    category: "protocols",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "iot-smart-3",
    question: "What is CoAP in IoT?",
    options: [
      "A cloud storage service",
      "Constrained Application Protocol for resource-constrained devices",
      "A security framework",
      "A database management system"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "CoAP is a specialized web transfer protocol for use with constrained nodes and networks in IoT. It's designed for machine-to-machine applications like smart energy and building automation.",
    category: "protocols",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "iot-smart-4",
    question: "What is a sensor network in IoT?",
    options: [
      "A single sensor device",
      "A group of sensors that cooperate to monitor an area",
      "A cloud database",
      "An analytics dashboard"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "A sensor network is a collection of spatially distributed sensors that work together to monitor physical or environmental conditions, transmitting data to a central location.",
    category: "sensor-networks",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "iot-smart-5",
    question: "What is time-series data in IoT systems?",
    options: [
      "Historical archive data",
      "Data points indexed by timestamp showing changes over time",
      "Real-time video streams",
      "Static configuration files"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Time-series data consists of sequential data points collected over time intervals. It's crucial for IoT analytics to track sensor readings, detect patterns, and predict trends.",
    category: "data-management",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "iot-smart-6",
    question: "What is the purpose of an IoT gateway?",
    options: [
      "Only store sensor data",
      "Bridge between sensors and the cloud, providing protocol translation and edge processing",
      "Replace all sensors",
      "Act as a user interface"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "IoT gateways act as intermediaries between sensors/devices and the cloud. They handle protocol translation, data aggregation, preprocessing, security, and can perform edge analytics.",
    category: "architecture",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "iot-smart-7",
    question: "What is device provisioning in IoT?",
    options: [
      "Installing software updates",
      "The process of securely onboarding and configuring devices",
      "Deleting old devices",
      "Monitoring device performance"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Device provisioning is the secure process of registering, authenticating, and configuring IoT devices to connect to the network and cloud services. It includes assigning credentials and policies.",
    category: "device-management",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "iot-smart-8",
    question: "What is OTA (Over-The-Air) updates in IoT?",
    options: [
      "Manual firmware installation",
      "Remote wireless software/firmware updates to devices",
      "Physical device replacement",
      "Cloud backup service"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "OTA updates allow remote deployment of software, firmware, or configuration changes to IoT devices over the network without physical access, essential for maintaining and securing deployed devices.",
    category: "device-management",
    points: 10,
    type: "multiple-choice"
  }
];

export const generateSmartIotSystemsQuiz = () => ({
  questions: SMART_IOT_SYSTEMS_QUIZ,
  passThreshold: 80,
  timeLimit: 900,
  category: 'iot-systems'
});
